import React from "react";
import { MachinesFetchAPI } from "../api/Machines";

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }


  static getDerivedStateFromError(error) {
    // No cambiamos el estado aquí, solo en componentDidCatch si es crítico
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // Considerar solo errores críticos que impidan el uso de la página
    // Ejemplo: errores de renderizado, errores de lógica no recuperables, etc.
    // Ignorar errores de red, validaciones, o errores menores


    // Solo errores que ponen la página en blanco (errores de renderizado de React)
    // Se asume que cualquier error atrapado aquí que no sea de red, validación o datos menores, es crítico
    // Si quieres ser aún más estricto, podrías filtrar por tipos específicos de error

    // Si el error ocurre en el ciclo de renderizado y no es de red ni validación, lo consideramos crítico
    const isRenderError = (
      !(error && (error.isAxiosError || error.response || error.request)) &&
      !(error && error.name === 'AxiosError') &&
      !(error && error.message && (
        error.message.includes('Network Error') ||
        error.message.includes('Failed to fetch') ||
        error.message.includes('timeout') ||
        error.message.toLowerCase().includes('validation') ||
        error.message.toLowerCase().includes('not found')
      ))
    );

    if (!isRenderError) {
      // No es un error que ponga la página en blanco
      return;
    }

    // Solo errores críticos de renderizado llegan aquí
    this.setState({ hasError: true });

    let business = JSON.parse(localStorage.getItem("business"));
    const errorText = `
    Error: ${error.toString()}
    Stack: ${errorInfo.componentStack}
    Fecha: ${new Date().toISOString()}
    Business: ${business?.code}
  `;
    const blob = new Blob([errorText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "error_log.txt";
    a.click();
    URL.revokeObjectURL(url);

    setTimeout(() => {
      this.recover();
    }, 1000);
  }

  // Un fallo de pantalla no es motivo para soltar la caja: si es la designada de comandas o auto-aprobacion,
  // otro equipo la toma y la sucursal se queda sin impresion. Primero se recarga conservando la sesion; solo si
  // el fallo se repite (2 recargas en 2 minutos, p.ej. un dato local corrupto) se hace el cierre completo de siempre.
  recover() {
    const MAX_RELOADS = 2;
    const WINDOW_MS = 2 * 60 * 1000;
    let recent = [];
    try {
      recent = JSON.parse(sessionStorage.getItem('error_boundary_reloads') || '[]')
        .filter((at) => Date.now() - at < WINDOW_MS);
    } catch (err) {
      recent = [];
    }

    if (recent.length < MAX_RELOADS) {
      try {
        sessionStorage.setItem('error_boundary_reloads', JSON.stringify([...recent, Date.now()]));
      } catch (err) { }
      window.location.reload();
      return;
    }

    this.signout();
  }

  //Function to logout of the payment post
  async signout() {
    let business = JSON.parse(localStorage.getItem("business"));
    let machine_token = localStorage.getItem('x-access-machine-token');
    let machine = JSON.parse(localStorage.getItem('machine_original'));

    if (!machine || !machine.code) {
      return;
    }

    let liberada = false;
    let errorMsg = '';
    try {
      const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
      if (response.data && response.data.success === true) {
        liberada = true;
      } else {
        errorMsg = response.data && response.data.error ? response.data.error : 'No se pudo liberar la máquina.';
      }
    } catch (err) {
      errorMsg = err?.response?.data?.error || err?.message || 'Error de red al liberar la máquina.';
    }

    if (liberada) {
      localStorage.clear();
      window.location.href = `/machines/login/${business.code}`;
    }
  }


  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff"
        }}>
          <div style={{ fontSize: 64, color: "#e74c3c", marginBottom: 16 }}>
            <i className="uil uil-exclamation-triangle"></i>
          </div>
          <h2 style={{ color: "#e74c3c", marginBottom: 8 }}>¡Ocurrió un error inesperado!</h2>
          <div style={{ color: "#555", fontSize: 18 }}>Redirigiendo al inicio de sesión...</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;